// extracted by mini-css-extract-plugin
module.exports = {"dimmer":"SuccessPopup_dimmer__24cwo","popup":"SuccessPopup_popup__1vSjX","popupContainer":"SuccessPopup_popupContainer__krKKj","popupClose":"SuccessPopup_popupClose__2koev"};